import Backend from 'App/Dataman-Backend';

const {
  apiUrlTypes,
  apiUrlProductFeatures,
  apiUrlProductFeatureOptions,
  apiUrlProductFeatureGroups,
  apiUrlCategories,
  apiUrlModules,
  apiUrlAdditionalFieldNames,
  apiUrlActivitySpheres,
  apiUrlSuffix,
} = Backend.config;

export const TAXONOMY_PATHS = {
  types: apiUrlTypes,
  features: apiUrlProductFeatures,
  featureOptions: apiUrlProductFeatureOptions,
  featureGroups: apiUrlProductFeatureGroups,
  categories: apiUrlCategories,
  modules: apiUrlModules,
  additionalFieldNames: apiUrlAdditionalFieldNames,
  activitySpheres: apiUrlActivitySpheres,
  suffix: apiUrlSuffix,
};
